import CountryList from '@/components/country/CountryList'

const CountriesPage = () => {
  return <CountryList />
}

export default CountriesPage
